import React, { useEffect, useState, useContext } from 'react'
import { Col, Row, Input, Card, message, List, Button, Spin, Checkbox } from 'antd'
import { TagOutlined, DollarOutlined, FundOutlined, CreditCardOutlined, LoadingOutlined } from '@ant-design/icons'
import UISpinner from '../../../components/UISpinner'
import PosSrc from '../PosSrc'
import DBService from '../../../utils/DBService'
import Utils from '../../../utils/Utils'
import PosPaymentModal from './PosPaymentModal'
import clientsSrc from '../../clients/clientsSrc'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import { Context, useStore } from '../../../context'

const { TextArea } = Input

function PosPayment(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const [paymentMethods, setPaymentMethods] = useState([])
  const [method, setMethod] = useState({})
  const [receivedCash, setReceivedCash] = useState(0)
  const [total, setTotal] = useState(0)
  const [creditDescription, setCreditDescription] = useState('')
  const [otherDescription, setOtherDescription] = useState('')
  const [clientName, setClientName] = useState('')
  const [nit, setNit] = useState(null)
  const [cf, setCf] = useState(false)
  const [address, setAddress] = useState(null)
  const [phone, setPhone] = useState(null)
  const [email, setEmail] = useState(null)
  const [clientsList, setClientsList] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false)
  const [visible, setVisible] = useState(null)
  const [clienteExoneradoCheck, setClienteExoneradoCheck] = useState(false)
  const [clienteExonerado, setClienteExonerado] = useState('')
  const initDataSource = JSON.stringify([{ id: 1, note: '' }])
  const initDataSourceHonduras = JSON.stringify([{ id: 1, note: 'NO SE REALIZAN CAMBIOS NI DEVOLUCIONES' }])
  const [dataSource, setDataSource] = useState(JSON.parse(props.country === 'Honduras' ? initDataSourceHonduras : initDataSource))

  useEffect(() => {
    if (props.quotationData && Object.keys(props.quotationData).length > 0) {
      setTotal(props.quotationData.id && props.quotationData?.client ? props.quotationData.total : props.total)
      setReceivedCash(props.quotationData.id && props.quotationData?.client ? props.quotationData?.total : props.total)
      setClientName(props.quotationData.id && props.quotationData?.client ? props.quotationData?.client?.name : '')
      setNit(props.quotationData.id && props.quotationData?.client ? props.quotationData?.client?.nit : '')
      setAddress(props.quotationData.id && props.quotationData?.client ? props.quotationData?.client?.address : '')
      setClienteExonerado(props.quotationData.id && props.quotationData?.municipality_ticket_code ? props.quotationData?.municipality_ticket_code : '')
      setClienteExoneradoCheck(props.quotationData.id && props.quotationData.exonerated_client ? props.quotationData.exonerated_client : '')

      if (props.quotationData?.notes && JSON.parse(props.quotationData?.notes).length > 0) {
        const data = JSON.parse(props.quotationData?.notes).map((p, i) => {
          const obj = {
            id: i,
            note: p
          }
          return obj
        })
        setDataSource(data)
      }
    } else {
      if (props.projectData && Object.keys(props.projectData).length > 0) {
        setTotal(props.projectData.id ? props.projectData.total : props.total)
        setReceivedCash(props.projectData.id ? props.projectData?.total : props.total)
        setClientName(props.projectData.id && props.projectData?.client ? props.projectData?.client?.name : '')
        setNit(props.projectData.id && props.projectData?.client ? props.projectData?.client?.nit : '')
        setAddress(props.projectData.id && props.projectData?.client ? props.projectData?.client?.address : '')

        if (props.projectData?.notes && JSON.parse(props.projectData?.notes).length > 0) {
          const data = JSON.parse(props.projectData?.notes).map((p, i) => {
            const obj = {
              id: i,
              note: p
            }
            return obj
          })
          setDataSource(data)
        }
      } else {
        if (props.sellInfo) {
          setTotal(props.sellInfo.total)
          setClientName(props.sellInfo.client_name)
          setNit(props.sellInfo.nit)
          setAddress(props.sellInfo.address)
          setPhone(props.sellInfo.phone)
          setEmail(props.sellInfo.email)
        } else {
          setTotal(props.total)
          setReceivedCash(props.total)
        }
      }
    }

    fetchPaymentMethods()
    // eslint-disable-next-line
  }, [props.quotationData, props.projectData])

  useEffect(() => {
    if (props.saveSell) {
      let validate = true
      if ([clientName, nit, address].some(v => !v)) {
        validate = false
        message.warning('Los campos NIT, Nombre y Dirección son obligatorios')
      }
      if (method.name === 'CASH' && Number(receivedCash) < Number(total)) {
        validate = false
        message.warning('El monto recibido es inferior al total')
      }
      if (!Utils.validateEmail(email) && email) {
        validate = false
        message.warning('Ingrese un email valido')
      }
      if (!Utils.validateNit(nit)) {
        validate = false
        message.warning('Ingrese un NIT valido')
      }

      if (method.name === 'CREDIT' && nit.length === 2 && nit.substring(0, 2).toLowerCase() === 'cf') {
        message.warning('El metodo de pago Crédito no acepta nit con CF')
        setNit('')
        resetClientInputs()
        validate = false
      }

      if (!validate) {
        return props.sellUnsaved && props.sellUnsaved()
      }

      let items = []
      if (props.quotationData.products && props.quotationData.products.length > 0) {
        items = props.quotationData.products.map(p => {
          if (!p.product) return null
          return {
            id: p.product,
            quote_id: p.quote_id,
            status: p.status,
            notes: p.notes,
            quantity: parseFloat(p.units),
            stock: p.stock ? p.stock : 0,
            no_stock_id: p.no_stock_id ? p.no_stock_id : null,
            unit_price: parseFloat(p.price),
            type: p.type,
            discount_id: p.discount_id,
            discount_amount: p.discount_amount
          }
        })
      } else {
        if (props.projectData.products && props.projectData.products.length > 0) {
          items = props.projectData.products.map(p => {
            if (!p.product) return null
            return {
              id: p.product,
              quote_id: p.quote_id,
              status: p.status,
              notes: p.notes,
              quantity: parseFloat(p.units),
              stock: p.stock ? p.stock : 0,
              no_stock_id: p.no_stock_id ? p.no_stock_id : null,
              unit_price: parseFloat(p.price),
              type: p.type,
              discount_id: p.discount_id,
              discount_amount: p.discount_amount
            }
          })
        } else {
          items = props.productsList.flatMap(p => {
            if (!p.product) return []

            const baseItem = {
              id: p.product,
              quote_id: p.quote_id,
              status: p.status,
              notes: p.notes,
              quantity: parseFloat(p.units),
              stock: p.stock ? p.stock : 0,
              no_stock_id: p.no_stock_id ? p.no_stock_id : null,
              unit_price: parseFloat(p.price),
              type: p.type,
              discount_id: p.discount_id,
              discount_amount: p.discount_amount
            }

            if (p.type !== 'COMBO') return [baseItem]

            // Identifica esta aparición puntual del combo en el carrito, para que
            // el backend agrupe sus presentaciones (y los extras agregados) bajo
            // la misma instancia, aunque el mismo combo se repita en la venta.
            const comboInstanceId = `combo-${p.id}`
            baseItem.combo_instance_id = comboInstanceId
            baseItem.kept_presentation_ids = p.kept_presentation_ids || null

            const extraItems = (p.combo_extras || []).map(extra => ({
              id: extra.presentation_id,
              quantity: parseFloat(extra.quantity),
              unit_price: parseFloat(extra.unit_price),
              type: 'PRESENTATION',
              discount_id: null,
              discount_amount: 0,
              combo_instance_id: comboInstanceId,
            }))

            return [baseItem, ...extraItems]
          })
        }
      }

      const notes = dataSource.map((item) => {
        return item.note;
      });

      let data = {
        store_id: props.store.id,
        invoice_local: true,
        store_turn_id: state.turn.id,
        payment_method_id: method.id,
        description: method.name === 'CREDIT' ? creditDescription : otherDescription,
        name: clientName,
        nit: nit.toUpperCase(),
        address,
        phone: phone,
        email: email,
        items: items.filter(i => i),
        notes: notes,
        quote_id: props.quotationData.id ? props.quotationData.id : null,
        project_id: props.projectData.id ? props.projectData.id : null,
        exonerated_client: clienteExoneradoCheck,
        municipality_ticket_code: clienteExonerado,
        recipe: props.recipe
      }

      props.closeSell(data, validate)
    } else {
      props.sellUnsaved && props.sellUnsaved()
    }
    // eslint-disable-next-line
  }, [props.saveSell])

  useEffect(() => {
    if (props.completeSell) {
      if (method.name === 'CASH' && Number(receivedCash) < Number(total)) {
        message.warning('El monto recibido es inferior al total')
        return props.sellUncompleted && props.sellUncompleted()
      }

      let data = {
        store_id: props.store.id,
        store_turn_id: state.turn.id,
        payment_method_id: method.id,
      }
      props.paySell(data, props.sellInfo.id)
    } else {
      props.sellUncompleted && props.sellUncompleted()
    }
    // eslint-disable-next-line
  }, [props.completeSell])

  const fetchPaymentMethods = async () => {
    setLoadingPaymentMethods(true)
    const response = await PosSrc.getAllPaymentMethods(props.store.id)

    if (response.errors?.message[0] === 'Error de conexion') {
      let _paymentMethods = await DBService.getAll('paymentMethods')
      setPaymentMethods(props.paymentMethods)
      setMethod(_paymentMethods.find(p => p.name === 'CASH'))
      if (props.quotationData?.client?.nit === "CF" || props.projectData?.client?.nit === "CF") setClientInputsToCF()
      if (Object.keys(props.quotationData).length === 0 || Object.keys(props.projectData).length === 0) setClientInputsToCF()
    } else {
      setPaymentMethods(props.paymentMethods)
      setMethod(response.data.find(p => p.name === 'CASH'))
      DBService.add(response.data, 'paymentMethods')
      if (props.quotationData?.client?.nit === "CF" || props.projectData?.client?.nit === "CF") setClientInputsToCF()
      if (props.quotationData || props.projectData) {
        if (Object.keys(props.quotationData).length === 0 || Object.keys(props.projectData).length === 0) setClientInputsToCF()
      }
    }

    setLoadingPaymentMethods(false)
  }

  const searchByNit = e => {
    if ((e.key === 'Enter' || e === 'searchButton') && nit?.toLowerCase() !== 'cf') {
      if (!Utils.validateNit(nit)) return message.warning('Ingrese un NIT valido')
      setLoadingClients(true)

      clientsSrc
        .clientOptions({ nit })
        .then(async response => {
          if (response === 'Unauthenticated.') throw new Error('Unauthenticated')
          if (response.errors?.message[0] === 'Error de conexion') {
            let _clients = await DBService.getAll('clients')
            let client = _clients.filter(c => c.nit?.toLowerCase() === nit?.toLowerCase())
            if (client.length === 0) {
              setAddress(null)
              setPhone(null)
              setEmail(null)
              setClientName('')
              setLoadingClients(false)
              return message.warning('El NIT que ingreso no se encuentra registrado')
            } else {
              const { address, name, companies } = client[0]
              setAddress(address)
              setPhone((companies[0] && companies[0]?.pivot?.phone) || null)
              setEmail((companies[0] && companies[0]?.pivot?.email) || null)
              setClientName(name)
            }
          } else {
            if (!response.data || !response.data.data || response.data.data.length === 0) {
              setAddress(null)
              setPhone(null)
              setEmail(null)
              setClientName('')
              setLoadingClients(false)
              return message.warning('El NIT que ingreso no se encuentra registrado')
            }

            const { address, name, companies } = response.data.data[0]
            setAddress(address)
            setPhone((companies[0] && companies[0]?.pivot?.phone) || null)
            setEmail((companies[0] && companies[0]?.pivot?.email) || null)
            setClientName(name)
          }
          setLoadingClients(false)
        })
        .catch(e => {
          console.log(e)
          message.error('No se ha podido cargar la información del cliente.')
          setLoadingClients(false)
        })
    }
  }

  const SearchButton = <SearchOutlined className="search-addon-after" onClick={e => searchByNit('searchButton')} />
  const LoadingSpinner = <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />

  const addClient = data => {
    setClientsList([...clientsList, data])
    setVisible(false)
  }

  const setClientInputsToCF = async () => {
    let posSrc = null

    try {
      posSrc = await PosSrc.getStore(props.store.id)
    } catch (error) {
      console.log(error);
    }
    
    if (!(props.total >= 10000 && posSrc.company.country.name === 'Honduras') && !props.quotationData.id && !props.quotationData?.client) {
      setNit('CF')
      setClientName('Cliente final')
      setAddress('Ciudad')
      setCf(true)
    }
  }

  const resetClientInputs = () => {
    setClientName(null)
    setAddress(null)
    setCf(false)
  }

  const iconMethod = icon => {
    let iconCorrect
    switch (icon) {
      case 'CASH':
        iconCorrect = <DollarOutlined />
        break

      case 'CARD':
        iconCorrect = <CreditCardOutlined />
        break

      case 'CREDIT':
        iconCorrect = <TagOutlined />
        break

      default:
        iconCorrect = <FundOutlined />
        break
    }
    return iconCorrect
  }

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    x = Number(x);
    decimalDigits = Number(decimalDigits);

    x = x * (10 ** decimalDigits);
    x = x - x % 1;
    x = x / (10 ** decimalDigits);

    if (returnText)
      if (longFixed)
        return x.toFixed(decimalDigits);
      else
        return x.toString();
    else
      return x;
  }

  const cash = () => {
    return (
      <>
        <Row gutter={16}>
          <Col sm={12}>
            <div className={'title-space-field title-space-top pl-2'}>Efectivo recibido</div>
            <Input
              prefix={props.symbol}
              value={trunc(receivedCash)}
              onChange={e => setReceivedCash(e.target.value)}
              placeholder={'Ingresa el monto recibido'}
              size={'large'}
            />
            <div className={'title-space-field title-space-top pl-2'}>Total</div>
            <Input disabled={true} value={`${props.symbol} ${trunc(total)}`} size={'large'} />
          </Col>
          <Col sm={12} className={'cash-change'}>
            Cambio: <span>{props.symbol} {trunc(receivedCash - total < 0 ? 0 : receivedCash - total)}</span>
          </Col>
        </Row>
      </>
    )
  }

  const card = () => {
    return (
      <>
        <Row gutter={16}>
          <Col sm={24}>
            <div className={'title-space-field title-space-top pl-2'}>1) Haz el cobro en tu dispositivo para cobros con tarjeta.</div>
            <div className={'title-space-field title-space-top pl-2'}>2) Luego, termina la operación presionando el botón "Finalizar venta".</div>
          </Col>
        </Row>
      </>
    )
  }

  const credit = () => {
    return (
      <>
        <Row gutter={16}>
          <Col sm={24}>
            <div className={'title-space-field title-space-top pl-2'}>Datos de cobro</div>
            <TextArea onChange={e => setCreditDescription(e.target.value)} placeholder={'Descripción de crédito/vale'} size={'large'} rows={3} />
          </Col>
        </Row>
      </>
    )
  }

  const other = () => {
    return (
      <>
        <Row gutter={16}>
          <Col sm={24}>
            <Input onChange={e => setOtherDescription(e.target.value)} placeholder={'Descripción'} size={'large'} />
          </Col>
        </Row>
      </>
    )
  }

  const onAdd = () => {
    if (dataSource.length > 2) return

    setDataSource(prevState => {
      const sorted = prevState.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      const newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem.id + 1 })
      return [...sorted, newRow]
    })
  }

  const onDelete = (e, rowId) => {
    if (dataSource.length === 1) return

    setDataSource(prevState => {
      const value = prevState.flatMap(row => (row.id !== rowId ? row : []))
      return value
    })
  }

  const onSetNotes = (value, rowId) => {
    const newDataSource = dataSource.map(row => {
      if (row.id === rowId) {
        return Object.assign(row, { note: value })
      }
      return row
    })

    setDataSource(newDataSource)
  }

  return (
    <>
      <PosPaymentModal visible={visible} addClient={addClient} visibleStatus={status => setVisible(status)} />
      <h4 className={'section-space-list-bottom'}>{props.edit ? 'Pago de cuenta por cobrar' : 'Cobro de producto'}</h4>
      <Row gutter={16}>
        <Col sm={12} className={loadingPaymentMethods && 'payment-methods'}>
          {loadingPaymentMethods ? (
            <UISpinner />
          ) : (
            <>
              <div className={'title-space-field title-space-top pl-2'}>Métodos de pago </div>
              <Row gutter={20} align={'top'}>
                {paymentMethods.map((value, id) =>
                  (value.name === 'CREDIT' && props.edit) || (value.name === 'CREDIT' && !hasPermissions([58])) ? (
                    ''
                  ) : (
                    <Col sm={8} key={id}>
                      <Card onClick={() => setMethod(value)} className={method.name === value.name && 'active'}>
                        {iconMethod(value.description)}
                        {Utils.jsUcfirst(Utils.translatePaymentMethod(value.description))}
                      </Card>
                    </Col>
                  )
                )}
                <Col sm={24}>
                  {method.name === 'CASH' && cash()}
                  {method.name === 'CARD' && card()}
                  {hasPermissions([58]) && method.name === 'CREDIT' && !props.edit && credit()}
                  {method.name !== 'CASH' && method.name !== 'CARD' && method.name !== 'CREDIT' && other()}
                </Col>
              </Row>
            </>
          )}
        </Col>
        <Col sm={2}>
          <div className="sell-divider"></div>
        </Col>
        <Col sm={10}>
          <Row gutter={16}>
            <Col sm={24} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <div className={'title-space-field title-space-top pl-2'}>Facturación</div>
              <Checkbox disabled={ cf } checked={clienteExoneradoCheck} onChange={e => setClienteExoneradoCheck(e.target.checked)}>Cliente exonerado</Checkbox>
            </Col>
            <Col sm={24} className={'client-info'}>
              <Input
                disabled={props.edit}
                onKeyDown={searchByNit}
                addonAfter={loadingClients ? LoadingSpinner : SearchButton}
                onChange={e => {
                  setNit(e.target.value)
                  if (e.target.value.toLowerCase() === 'cf') {
                    setClientInputsToCF()
                  } else {
                    resetClientInputs()
                  }
                }}
                value={nit}
                placeholder={'NIT (presiona enter para buscar)'}
                size={'large'}
              />
              <Input
                disabled={(props.edit || cf)}
                value={clientName}
                onChange={e => setClientName(e.target.value)}
                placeholder={'Nombre cliente'}
                size={'large'}
              />
              <Input
                disabled={(props.edit || cf)}
                value={address}
                onChange={e => setAddress(e.target.value)}
                placeholder={'Dirección'}
                size={'large'}
              />
              <Input
                disabled={(props.edit || cf)}
                value={phone}
                onChange={e => setPhone(e.target.value)}
                placeholder={'Teléfono'}
                size={'large'}
              />
              <Input
                disabled={(props.edit || cf)}
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={'Correo electrónico'}
                size={'large'}
              />
              <Input
                disabled={(props.edit || cf || !clienteExoneradoCheck)}
                value={clienteExonerado}
                onChange={e => setClienteExonerado(e.target.value)}
                placeholder={'Cliente exonerado'}
                size={'large'}
              />
              <div className="total-bill">
                <div>
                  TOTAL A PAGAR
                  <span>{props.symbol} {trunc(total)}</span>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className={'title-space-field'}>Notas:</div>
          <List
            id={'inventory-list'}
            size="large"
            rowKey="id"
            dataSource={dataSource}
            renderItem={(row, i) => (
              <List.Item>
                <Row gutter={16} align="bottom" className={'section-space-field w-100'} key={row.id}>
                  <Col sm={1}>
                    <div className={'title-space-bottom text-bold'}>{i + 1}</div>
                  </Col>
                  <Col sm={20}>
                    <Input value={row.note} onChange={e => onSetNotes(e.target.value, row.id)} placeholder={'Escribir Notas'} size={'large'} />
                  </Col>
                  <Col sm={3} className={'center-flex-div'}>
                    <Button type={'link'} className="title-space-bottom cancel-button px-0 m-0" onClick={e => onDelete(e, row.id)}>
                      Eliminar
                    </Button>
                  </Col>
                </Row>
              </List.Item>
            )}
            footer={
              <Row gutter={16} className={'section-space-field'}>
                <Col sm={1}></Col>
                <Col sm={9}>
                  <div className="title-tendero dashed-border-button" onClick={onAdd}>
                    <svg className={'svg'} viewBox="0 0 300 100" preserveAspectRatio="none">
                      <path className={'path'} d="M0,0 300,0 300,100 0,100z" />
                    </svg>
                    <span className={'text'}>Agregar Nota</span>
                  </div>
                </Col>
              </Row>
            }
          />
        </Col>
      </Row>
    </>
  )
}

export default PosPayment
